import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const heroiconsArrowPathRoundedSquare = svgToTinyDataUri(
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
  <path d="M7 19H4l2.5-4H4.5l3.5-6 3.5 6H9.5L12 19"/>
  <path d="M17 19h3l-2.5-4h2l-3.5-6-3.5 6h2L12 19"/>
  <path d="M12 5l2 3.5h-1.5L12 10l-.5-1.5H10l2-3.5"/>
</svg>`
);
